w<!-- ==========================================================================================
    File Name: Create.vue
    Description: Create Customers Page
========================================================================================== -->

<template>
        <div id="create-customers-page">
                <vx-card>
                        <!-- Personal Data -->
                        <div class="vx-row leading-loose mt-3">
                                <div class="vx-col w-full md:w-1/2">
                                        <h4>Datos personales</h4>
                                </div>
                        </div>
                        <!-- Row -->
                        <div class="vx-row leading-loose mt-3">
                                <div class="vx-col w-full md:w-1/2">
                                        <vs-input
                                                v-model="userData.firstName"
                                                v-validate="'required|alpha_spaces'"
                                                name="nombre"
                                                label="Nombre"
                                                class="w-full no-icon-border"
                                        />
                                        <span v-show="errors.has('nombre')" class="text-danger text-sm">{{
                                                errors.first('nombre')
                                        }}</span>
                                </div>
                                <div class="vx-col w-full md:w-1/2">
                                        <vs-input
                                                v-model="userData.lastName"
                                                v-validate="'required|alpha_spaces'"
                                                name="apellidos"
                                                label="Apellidos"
                                                class="w-full no-icon-border"
                                        />
                                        <span v-show="errors.has('apellidos')" class="text-danger text-sm">{{
                                                errors.first('apellidos')
                                        }}</span>
                                </div>
                        </div>
                        <!-- end row -->
                        <!-- Row -->
                        <div class="vx-row leading-loose mt-3">
                                <div class="vx-col w-full md:w-1/3">
                                        <vs-input
                                                v-model="userData.email"
                                                v-validate="'required|email'"
                                                name="email"
                                                label="Email"
                                                class="w-full no-icon-border"
                                        />
                                        <span v-show="errors.has('email')" class="text-danger text-sm">{{
                                                errors.first('email')
                                        }}</span>
                                </div>
                                <div class="vx-col w-full md:w-1/3">
                                        <vs-input
                                                v-model="userData.phone"
                                                name="telefono"
                                                label="Telefono de contacto"
                                                class="w-full no-icon-border"
                                        />
                                </div>
                                <div class="vx-col w-full md:w-1/3">
                                        <vs-input
                                                v-model="userData.parqueadero_asignado"
                                                name="parqueadero_asignado"
                                                label="Parqueadero Asignado"
                                                class="w-full no-icon-border"
                                        />
                                </div>
                        </div>
                        <!-- end row -->
                        <!-- Row -->
                        <div class="vx-row leading-loose mt-3">
                                <div class="vx-col w-full md:w-1/4">
                                        <vs-input
                                                v-model="userData.cc"
                                                v-mask="'9.999.999.999'"
                                                v-validate="{ required: true, regex: /^[1-9].?\d{3}.?\d{3}.?\d{3}$/ }"
                                                name="cc"
                                                label="Cedula de Ciudadania"
                                                class="w-full no-icon-border"
                                        />
                                        <span v-show="errors.has('cc')" class="text-danger text-sm">{{
                                                errors.first('cc')
                                        }}</span>
                                </div>
                                <div class="vx-col w-full md:w-1/4">
                                        <vs-input
                                                v-model="userData.coeficiente"
                                                v-validate="'required|between:0,100'"
                                                name="coeficiente"
                                                type="number"
                                                min="0"
                                                max="100"
                                                label="Coeficiente Asignado"
                                                class="w-full no-icon-border"
                                        />
                                        <span v-show="errors.has('coeficiente')" class="text-danger text-sm">{{
                                                errors.first('coeficiente')
                                        }}</span>
                                </div>
                                <div class="vx-col w-full md:w-1/4">
                                        <vs-select
                                                v-model="userData.bloque"
                                                class="w-full select-large"
                                                label="Bloque"
                                                no-data="No hay bloques aún"
                                                autocomplete
                                                @change="selectedBloque(userData.bloque)"
                                        >
                                                <vs-select-item
                                                        v-for="(item, index) in bloques"
                                                        :key="index"
                                                        :value="item.nombre_bloque"
                                                        :text="item.nombre_bloque"
                                                        class="w-full"
                                                />
                                        </vs-select>
                                </div>
                                <div class="vx-col w-full md:w-1/4">
                                        <vs-select v-model="userData.unidad" class="w-full select-large" label="Unidad">
                                                <vs-select-item
                                                        v-for="(item, index) in unidades"
                                                        :key="index"
                                                        no-data="Selecciona un bloque"
                                                        :value="item.id"
                                                        :text="item.nombre_unidad"
                                                        class="w-full"
                                                />
                                        </vs-select>
                                </div>
                        </div>
                        <!-- end row -->
                        <!-- start row -->
                        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-10" vs-w="12">
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="12">
                                        <vs-button
                                                color="primary"
                                                type="filled"
                                                icon-pack="FA5"
                                                icon="far fa-save"
                                                @click="createUser()"
                                                >Crear Cliente</vs-button
                                        >
                                </vs-col>
                        </vs-row>
                        <!-- end row -->
                        <!-- end Personal Data -->
                </vx-card>
        </div>
</template>

<script>
import { mapState } from 'vuex';
import AwesomeMask from 'awesome-mask';

import { Validator } from 'vee-validate';
const dict = {
        custom: {
                coeficiente: {
                        between: 'Este campo requiere valores entre 0 y 100',
                        required: 'Este campo es requerido',
                },
                email: {
                        email: 'Este campo requiere un email valido',
                        required: 'Este campo es requerido',
                },
                nombre: {
                        alpha_spaces: 'En este campo solo se permiten letras y espacios',
                        required: 'Este campo es requerido',
                },
                apellidos: {
                        alpha_spaces: 'En este campo solo se permiten letras y espacios',
                        required: 'Este campo es requerido',
                },
                cc: {
                        regex: 'Formato invalido, se requiere 1.111.111.111, maximo 10 digitos',
                        required: 'Este campo es requerido',
                },
        },
};
// register custom messages
Validator.localize('en', dict);

export default {
        data() {
                return {
                        userData: {
                                firstName: '',
                                lastName: '',
                                email: '',
                                phone: '',
                                cc: '',
                                parqueadero_asignado: '',
                                coeficiente: '',
                                bloque: '',
                                unidad: 'unidad-1',
                                conjunto: this.$store.state.conjuntos[0].id,
                        },
                        unidades: [],
                };
        },
        computed: {
                ...mapState(['bloques']),
        },
        methods: {
                createUser() {
                        this.$store
                                .dispatch('crearCliente', this.userData)
                                .then(res => {
                                        this.openAlert('success', res.message);
                                        this.$router.push({ name: 'listUsers' });
                                })
                                .catch(err => console.log(err.message));
                },
                openAlert(color, message) {
                        this.colorAlert = color || this.getColorRandom();
                        this.$vs.dialog({
                                color: this.colorAlert,
                                title: 'Aviso',
                                text:
                                        this.colorAlert === 'danger'
                                                ? ' Ocurrio un error, por favor contacta al administrador'
                                                : message,
                                accept: this.acceptAlert,
                        });
                },
                acceptAlert() {
                        this.$vs.notify({
                                color: this.colorAlert,
                                title: 'Aviso',
                                text:
                                        this.colorAlert === 'danger'
                                                ? ' Por favor revisa todos los campos'
                                                : 'Continuemos',
                        });
                },
                selectedBloque(value) {
                        this.$store
                                .dispatch('getUnidades', value)
                                .then(result => {
                                        this.unidades = result[0];
                                })
                                .catch(err => {
                                        console.log(err);
                                });
                },
        },
        directives: {
                mask: AwesomeMask,
        },
};
</script>
